import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class PtReservationScheduleService {
  private api = inject(ApiService);

  get(id: number) { return this.api.get(`/reservation/schedule/${id}`); }
  getAll(studioId: number) { return this.api.get(`/reservation/schedule/studio/${studioId}`); }
  create(json: any) { return this.api.post('/reservation/schedule', json); }
  update(json: any) { return this.api.post('/reservation/schedule/update', json); }
  remove(json: any) { return this.api.post('/reservation/schedule/remove', json); }
}
